/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { pageContainerStyles } from "@monsma/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { css } from "styled-components";

pageContainerStyles.xStyle = {
    pageContainer: {
        css: css`
            ${({ active }: any) => !active && "display:none;"}
        `,
    },
};

pageContainerStyles.promoCodeGridItem = {
    css: css`
        display: none;
    `,
};
pageContainerStyles.promoCodeAndCartTotalGridItem = {
    ...pageContainerStyles.promoCodeAndCartTotalGridItem,
    css: css`
        ${pageContainerStyles.promoCodeAndCartTotalGridItem?.css}
        position: relative;
    `,
};
pageContainerStyles.promoCodeAndCartTotalContainer = {
    ...pageContainerStyles.promoCodeAndCartTotalContainer,
    gap: 10,
    css: css`
        position: sticky;
        top: 125px;
    `,
};
pageContainerStyles.cartTotalGridItem = {
    ...pageContainerStyles.cartTotalGridItem,
    css: css`
        position: sticky;
        top: 100px;
    `,
};

pageContainerStyles.actionButtonsBottomGridItem = {
    width: 12,
    css: css`
        order: 4;
    `,
};

pageContainerStyles.loadingOverlay = {};
